module.exports = __webpack_public_path__ + "img/mind_skeleton_9.5dd8d2a0.png";